import { isFunction } from 'lodash'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Closer from './Closer'

type TWrapper = {
  withPadding?: boolean
  isHovered?: boolean
  success?: boolean
}
type TContent = {
  isHovered?: boolean
}
const Wrapper = styled.div<TWrapper>`
  display: flex;
  align-items: center;
  background-color: rgba(
    ${({ success }) => (success ? '239, 255, 234' : '255, 239, 234')},
    ${({ isHovered }) => (isHovered ? '1' : '0')}
  );
  padding: ${({ withPadding }) => (withPadding ? '0.5rem 0.5rem' : '')};
`

const Content = styled.div<TContent>`
  flex: 1;
  position: relative;
  opacity: ${({ isHovered }) => (isHovered ? 0.5 : 1)};
`

type TRemovable = {
  children?: React.ReactNode
  onRemove?: () => void
  withPadding?: boolean
  closerIcon?: string
  padRight?: boolean
  tooltip?: string
  success?: boolean
}

const Removable = (props: TRemovable): React.ReactElement => {
  const {
    children,
    onRemove,
    withPadding,
    closerIcon,
    padRight,
    tooltip,
    success,
  } = props

  const [isHovered, setIsHovered] = useState(false)

  // Prevent missing unhover when switching from removable to non removable
  useEffect(() => {
    if (!onRemove) {
      setIsHovered(false)
    }
  }, [onRemove])

  return (
    <Wrapper isHovered={isHovered} withPadding={withPadding} success={success}>
      <Content isHovered={isHovered}>{children}</Content>
      <div style={{ minWidth: padRight || onRemove ? '30px' : '' }}>
        {isFunction(onRemove) && (
          <Closer
            isHovered={isHovered}
            setIsHovered={setIsHovered}
            onClick={onRemove}
            closerIcon={closerIcon}
            tooltip={tooltip}
          />
        )}
      </div>
    </Wrapper>
  )
}

export default Removable
